import { render, staticRenderFns } from "./AdminHomePage.vue?vue&type=template&id=42873ab8&scoped=true"
import script from "./AdminHomePage.vue?vue&type=script&lang=js"
export * from "./AdminHomePage.vue?vue&type=script&lang=js"
import style0 from "./AdminHomePage.vue?vue&type=style&index=0&id=42873ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42873ab8",
  null
  
)

export default component.exports